import { NewBuildingQuizRoute } from '@search/nb-routes/src/NewBuildingQuizRoute';

import initBrowserApp from '../../../../client/common/libs/init-browser-app';
import NotFoundPage from '../../../../client/desktop/components/NotFoundPage';

import instanceConfig from '../../config';

import { linkBuilder } from '../../routes/routes';
import NewBuildingQuizPage from '../../../../client/desktop/components/NewBuildingQuizPage';
import NewBuildingQuizPageSeo from '../../../../client/common/components/NewBuildingQuizPageSeo';

import '../../components/common/styles.css';
import '../../components/desktop/styles.css';

initBrowserApp({
    routes: [
        {
            type: 'NewBuildingQuizRoute',
            route: NewBuildingQuizRoute,
            Component: NewBuildingQuizPage,
            SeoComponent: NewBuildingQuizPageSeo
        }
    ],
    linkBuilder,
    instanceConfig,
    components: {
        NotFoundPage
    }
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
// @ts-ignore
if (typeof module.hot === 'object') {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    module.hot.accept();
}
